export enum ActionType {
  OnPageLoad = 'OnPageLoad', // The modal shows up when the page is loaded and there is no user interaction.
  OnClick = 'OnClick',
}

export interface LoadingLogData {
  action: ActionType;
  component: string; // Component name
  description?: string; // What is this loading animation for
  context?: unknown; // Provide more context as much as possible. E.g. resourceId, endpoint name, etc.
}

export interface ErrorLogData {
  action: ActionType;
  component: string; // Component name
  description?: string; // What is this loading animation for
  context?: unknown; // Provide more context as much as possible. E.g. resourceId, endpoint name, etc.
  error?: unknown;
}
